let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("avS1q")).then(() => parcelRequire('bvbVP'));